import React, { memo, useCallback, useState, useEffect } from "react";
import { formatPrice } from "@utils/format";

import "./HistoryCard.scss";
import { HistoryPaymentDataType } from "@store/HistoryPayment";
import Swal from "sweetalert2";
import { observer } from "mobx-react-lite";
import { useMst } from "@store/Route";

interface HistoryCardProps extends HistoryPaymentDataType {
  token: string;
}

const HistoryCard = observer(
  ({
    token,
    pdfUrl,
    taggedCreditNotes,
    accountingDocumentId,
    description,
    accountingDocumentNumber,
    originalAmount,
    label,
  }: HistoryCardProps) => {
    const { Invoices } = useMst();

    const [isHideDetail, setIsHideDetail] = useState(true);

    const projectCodeTag = useCallback(() => {
      if (label === undefined || label === null) {
        return null;
      }
      if (label === "DailyBus") {
        return (
          <label
            className={`outstandingCard__labelText`}
            style={{
              backgroundColor: "red",
            }}
          >
            Daily Bus
          </label>
        );
      }
      if (label === "Adhoc") {
        return (
          <label
            className={`outstandingCard__labelText`}
            style={{
              backgroundColor: "red",
            }}
          >
            AD-HOC
          </label>
        );
      }
    }, [label]);

    const openPdf = useCallback(() => {
      if (token && accountingDocumentId) {
        Invoices.getInvoices(token, accountingDocumentId, (callback) => {
          window.open(callback.pdfUrl);
        });
      } else {
        Swal.fire("ID Parent Not Found");
      }
    }, [accountingDocumentId]);

    return (
      <div
        key={accountingDocumentId}
        className={`w-100 onProcessCard__mainWrapper`}
      >
        <div className="row">
          <div className="col-9">
            <div className="col-11">
              <p className="onProcessCard__ticketNo header--18">{`Invoice - ${accountingDocumentNumber}`}</p>

              <p className="onProcessCard__descriptionText">{description}</p>
            </div>
          </div>
          <div className="col-sm-3 row onProcessCard__wrapperTag">
            <div className="col-8 onProcessCard__center">
              <div className="onProcessCard__labelWrapper">
                {projectCodeTag()}
              </div>
            </div>
            {pdfUrl ? (
              <div className="paymentItem__center col-4">
                <div onClick={openPdf} className="btnTicketPDF" />
              </div>
            ) : null}
          </div>
        </div>
        <div className="row mt-2">
          <div className={`col-8`}>
            <div className="row">
              <div className="col-sm-4">
                {originalAmount ? (
                  <>
                    <label className="lableAmount">Original Amount</label>
                    <div className={`priceText`}>
                      {`${formatPrice(originalAmount)}`}
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        {taggedCreditNotes && taggedCreditNotes.length !== 0 ? (
          <div className="w-full flex justify-end">
            <div
              onClick={() => setIsHideDetail(!isHideDetail)}
              className="hide"
            >
              {isHideDetail ? "Show Detail" : "Hide Detail"}
            </div>
          </div>
        ) : null}
        {!isHideDetail
          ? taggedCreditNotes &&
            taggedCreditNotes.map((taggedCreditNote) => (
              <div key={taggedCreditNote.accountingDocumentNumber}>
                <div className="line" />
                <div className="row">
                  <div className="col-sm-9 row">
                    <div className="lineItem" />
                    <div className="col-10">
                      <p className="onProcessCard__ticketNo header--18 color--green">
                        {`Credit Note - ${taggedCreditNote.accountingDocumentNumber}`}
                      </p>

                      {taggedCreditNote.amount ? (
                        <>
                          <label className="lableAmount">Amount</label>
                          <div className={`priceText`}>
                            {`${formatPrice(
                              Math.abs(taggedCreditNote.amount)
                            )}`}
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ))
          : null}
      </div>
    );
  }
);

export default memo(HistoryCard);
